import React from "react";
import { Button, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";

import FloatingLabelInput from "../../../common/components/FloatingLabelInput";
import FormSelect from "../../../common/components/FormSelect";

const SearchFilters = ({
  filterOptions: {
    location_options: locationOptions,
    grade_options: gradeOptions,
  },
  filters,
  openStats,
  setFieldValue,
  setFilters,
  setShowSideBar,
}) => {

  return (
    <>
      <Row className="mb-3 mt-4 me-3">
        <Col xs={6}>
          <FloatingLabelInput
            label="Search student name or ID, date of birth"
            value={filters.q_student}
            onChange={(e) => setFieldValue("q_student", e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && setFilters({ ...filters, q_student: e.target.value })}
            ariaLabel="Search by name or barcode"
            className="d-sm-block flex-md-fill mb-3 mb-md-0"
            style={{ minWidth: "305px" }}
            prependIcon="search"
          />
        </Col>
        <Col xs={2}>
          <FormSelect
            prompt="Grade"
            options={gradeOptions}
            onChange={(option) => setFieldValue("grade", option)}
            selected={filters.grade}
          />
        </Col>
        <Col xs={2}>
          <FormSelect
            prompt="Location"
            options={locationOptions}
            onChange={(id) => setFieldValue("location", id)}
            selected={filters.location}
          />
        </Col>
        <Col xs={2} className="my-auto">
          <div className="d-flex justify-content-around">
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip className="tooltip-small">All filters</Tooltip>}
            >
              <a
                className="btn btn-link text-primary inter semibold mx-1 mx-md-3 my-auto"
                type="button"
                aria-expanded="false"
                aria-controls="studentProfilesFiltersSideBar"
                onClick={setShowSideBar}
              >
                <i className="fa-regular fa-bars-filter"></i>
              </a>
            </OverlayTrigger>
            <div
              className="my-auto mx-3"
              style={{
                border: "1px solid #A0ABC0",
                width: "1px",
                height: "38px",
              }}
            ></div>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip className="tooltip-small">Stats by service</Tooltip>}
            >
              <Button
                className="mx-3"
                onClick={openStats}
                variant="outline-tertiary"
                style={{ minWidth: "90px" }}
              >
                Stats
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SearchFilters;